import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from 'mobx-react';
import styles from "./game-scoreboard.module.scss";
import classNames from "classnames";
import {GameCardScoreboardViewModel} from "../game-card/view-models/game-card.scoreboard.view-model";

export class GameScoreboardCellProps extends BaseProps {
  index: Number;
  stage: GameCardScoreboardViewModel;
}

export const GameScoreboardCell = observer(({
                                              index,
                                              stage
                                            }: GameScoreboardCellProps) => {
  const score = stage.scores[index];
  const extraScore = stage.extraScores[index];
  const isMain = stage.isMain;
  const isWinner = index === stage.winnerScoreIndex;
  const isInPossession = stage.isMain && (index === stage.competitorInPossessionIndex);

  return (<div className={classNames(styles.cell, {[styles.main]: isMain, [styles.winner]: isWinner})}>{score}
        {
          extraScore ? <span className={classNames(styles.extra_score)}>{extraScore}</span> : null
        }
        {
          isInPossession ? <span className={classNames(styles.possession_indicator)}></span> : null
        }
      </div>
  )
});
